import { TimeDataInterface } from "./../LinkRestriction/types";
import { curbLinkObject } from "components/curb/map/deckgl/interfaces";
import { daysOfWeek } from "../../Utilities/dateTimeUtilities";
import { GetRequestSingleItemInterface } from "../../interfaces/ActionReducer/GetMethod/GetRequestSingleItem";
import { GetRequestWithoutLimitOffset } from "../../interfaces/ActionReducer/GetMethod/GetRequestWithoutLimitOffset";
import { GetResponseInterface } from "../../interfaces/ActionReducer/GetMethod/GetResponse";
import { GetRequestInterface } from "../../interfaces/ActionReducer/GetRequest/GetRequest";
import { CurbLinkRecord } from "../../interfaces/CurbLink";
import { SegmentObject } from "./interface";
import { ResetStateAction } from "components/curb/ManagerAnalyzer/Toggle/commonUtilities";
import { PermitParkingValue } from "actions/Filters/types";

export const UPDATE_FILTERED_LINKS = "UPDATE_FILTERED_LINKS";
export const UPDATE_FILTERED_PROPOSED_LINKS = "UPDATE_FILTERED_PROPOSED_LINKS";
export const GET_REGULATION_SECTION = "GET_REGULATION_SECTION";
export const REGULATION_SECTION_RECEIVED = "REGULATION_SECTION_RECEIVED";
export const TOGGLE_EDIT_REGULATION_PANEL = "TOGGLE_EDIT_REGULATION_PANEL";
export const TOGGLE_EDIT_OPTIONS_PANEL = "TOGGLE_EDIT_OPTIONS_PANEL";

export const GET_ALL_RESTRICTIONS = "GET_ALL_RESTRICTIONS";
export const GET_ALL_RESTRICTIONS_FOR_GIVEN_REGULATION_IDS =
    "GET_ALL_RESTRICTIONS_FOR_GIVEN_REGULATION_IDS";
export const ALL_RESTRICTIONS_RECEIVED = "ALL_RESTRICTIONS_RECEIVED";
export const COPY_REGULATION_TO_PROPOSED = "COPY_REGULATION_TO_PROPOSED";
export const REGULATION_TO_PROPOSED_POSTED = "REGULATION_TO_PROPOSED_POSTED";
export const GET_REGULATIONS_AND_RATES_FOR_SCENARIO = "GET_REGULATIONS_AND_RATES_FOR_SCENARIO";
export const REGULATION_AND_RATES_FOR_SCENARIO_RECEIVED =
    "REGULATION_AND_RATES_FOR_SCENARIO_RECEIVED";

// Proposed Regulation
export const GET_PROPOSED_REGULATION = "GET_PROPOSED_REGULATION";
export const PROPOSED_REGULATION_RECEIVED = "PROPOSED_REGULATION_RECEIVED";
export const ALL_PROPOSED_REGULATION_RECEIVED = "ALL_PROPOSED_REGULATION_RECEIVED";
export const GET_ALL_PROPOSED_REGULATIONS_BY_ID = "GET_ALL_PROPOSED_REGULATIONS_BY_ID";
export const UPDATE_PROPOSED_REGUATION = "UPDATE_PROPOSED_REGUATION";
export const PROPOSED_REGULATION_UPDATED = "PROPOSED_REGULATION_UPDATED";
export const DELETE_PROPOSED_REGULATION = "DELETE_PROPOSED_REGULATION";
export const PROPOSED_REGULATION_DELETED = "PROPOSED_REGULATION_DELETED";

// Proposed Restriction
export const GET_PROPOSED_RESTRICTION = "GET_PROPOSED_RESTRICTION";
export const PROPOSED_RESTRICTION_RECEIVED = "PROPOSED_RESTRICTION_RECEIVED";
export const UPDATE_PROPOSED_RESTRICTION = "UPDATE_PROPOSED_RESTRICTION";
export const PROPOSED_RESTRICTION_UPDATED = "PROPOSED_RESTRICTION_UPDATED";
export const DELETE_PROPOSED_RESTRICTION = "DELETE_PROPOSED_RESTRICTION";
export const PROPOSED_RESTRICTION_DELETED = "PROPOSED_RESTRICTION_DELETED";
export const POST_PROPOSED_RESTRICTION = "POST_PROPOSED_RESTRICTION";
export const CHECK_LINK_HAS_PROPOSED_REGULATION = "CHECK_LINK_HAS_PROPOSED_REGULATION";
export const CHECK_REGULATION_HAS_PROPOSED_REGULATION = "CHECK_REGULATION_HAS_PROPOSED_REGULATION";
export const RECEIVED_CHECK_REGULATION_HAS_PROPOSED_REGULATION =
    "RECEIVED_CHECK_REGULATION_HAS_PROPOSED_REGULATION";

// Regulation Links
export const GET_REGULATION_LINKS = "GET_REGULATION_LINKS";
export const GET_PROPOSED_REGULATION_LINKS = "GET_PROPOSED_REGULATION_LINKS";
export const REGULATION_LINKS_RECEIVED = "REGULATION_LINKS_RECEIVED";

export const TOGGLE_CREATE_OR_EDIT_ACTION_PERFORMED = "TOGGLE_CREATE_OR_EDIT_ACTION_PERFORMED";

export const REGULATION_REQUEST_ORIGINS = {
    BATCH_SELECTION: "BATCH_SELECTION",
    CREATE_REGULATION: "CREATE_REGULATION"
} as const;

export type RegulationRequestOrigin =
    (typeof REGULATION_REQUEST_ORIGINS)[keyof typeof REGULATION_REQUEST_ORIGINS];

export interface UpdateFilteredLinks {
    disabled: curbLinkObject;
    notDisabled: curbLinkObject;
}

export interface UpdateFilteredProposedLinks {
    disabled: curbLinkObject;
    notDisabled: curbLinkObject;
}

export interface UpdateFilteredLinksAction {
    type: typeof UPDATE_FILTERED_LINKS;
    payload: { filteredLinks: UpdateFilteredLinks };
}

export interface UpdateFilteredProposedLinksAction {
    type: typeof UPDATE_FILTERED_PROPOSED_LINKS;
    payload: { filteredProposedLinks: UpdateFilteredProposedLinks };
}

// Get Regulation

export type GetRegulationSection = GetRequestSingleItemInterface;

export interface GetRegulationSectionAction {
    type: typeof GET_REGULATION_SECTION;
    payload: { id: number; params: GetRegulationSection };
}

// Regulation Received
export type RegulationSectionReceived = { [prop: string]: any };

export interface RegulationSectionReceivedAction {
    type: typeof REGULATION_SECTION_RECEIVED;
    payload: { regulationSection: RegulationSectionReceived };
}

// Open Close Regulation
export type regulationId = number;
export type isEditRegulationPanelOpen = boolean;
export type IsEditOptionsPanelOpen = boolean;

// Get All Restrictions
// export type getRegulationsForScenario = GetRequestWithoutLimitOffset;

export interface AllRestrictionsReceivedRecord {
    id?: number;
    effective_date_from?: string;
    effective_date_to?: string;
    regulation?: {
        price?: string;
        time_limit?: string;
        regulationlinks_set?: Array<{ curb_link: CurbLinkRecord }>;
        payment?: {
            duration?: Array<number>;
            fees?: Array<number>;
        };
        effective_dates_period?: string;
    };
    days_of_week?: Array<daysOfWeek>;
    from_time?: string;
    to_time?: string;
}

export interface RateAndRegulationObjectInterface {
    [index: number]: {
        proposed_regulations: number[];
        regulations: number[];
    };
}

export interface RegulationsAndRatesForScenario {
    [index: string]: RateAndRegulationObjectInterface;
}

export interface AllRestrictionsReceived extends GetResponseInterface {
    results: Array<AllRestrictionsReceivedRecord & TimeDataInterface>;
}

export interface GetRegulationsAndRatesForScenarioAction {
    type: typeof GET_REGULATIONS_AND_RATES_FOR_SCENARIO;
    payload: {
        params: GetRequestWithoutLimitOffset;
    };
}
export interface RegulationsAndRatesForScenarioReceivedAction {
    type: typeof REGULATION_AND_RATES_FOR_SCENARIO_RECEIVED;
    payload: { regulationsAndRates: RegulationsAndRatesForScenario };
}

export interface GetAllRestrictionsAction {
    type: typeof GET_ALL_RESTRICTIONS;
    payload: { params: GetRequestWithoutLimitOffset };
}

export interface GetAllRestrictionsForGivenRegulationIdsAction {
    type: typeof GET_ALL_RESTRICTIONS_FOR_GIVEN_REGULATION_IDS;
    payload: {
        queryParams: GetRequestWithoutLimitOffset;
        bodyParams: {
            regulation_ids: Array<number>;
        };
    };
}

// All Restrictions Received
export interface AllRestrictionsReceivedAction {
    type: typeof ALL_RESTRICTIONS_RECEIVED;
    payload: { allRestrictions: AllRestrictionsReceived };
}

export interface toggleEditRegulationPanelAction {
    type: typeof TOGGLE_EDIT_REGULATION_PANEL;
    payload: { regulationId: regulationId; isEditRegulationPanelOpen: isEditRegulationPanelOpen };
}

export interface ToggleEditOptionsPanelAction {
    type: typeof TOGGLE_EDIT_OPTIONS_PANEL;
    payload: { isEditOptionsPanelOpen: IsEditOptionsPanelOpen };
}

// Copy Regulation to Proposed
export type copyRegulationPayload = { links: Array<number> };
export interface CopyRegulationToProposedAction {
    type: typeof COPY_REGULATION_TO_PROPOSED;
    payload: { regulationId: regulationId; links?: copyRegulationPayload["links"] };
}

export interface RegulationToProposedPosted {
    proposed_regulation_id: number;
}

export interface RegulationToProposedPostedAction {
    type: typeof REGULATION_TO_PROPOSED_POSTED;
    payload: { regulationToProposedPosted: RegulationToProposedPosted };
}

// Proposed Regulation

export type GetProposedRegulation = GetRequestSingleItemInterface;

export interface GetProposedRegulationAction {
    type: typeof GET_PROPOSED_REGULATION;
    payload: { params: GetProposedRegulation; regulationId: regulationId };
}

export type ProposedRegulationReceived = { [prop: string]: any };

export interface ProposedRegulationReceivedAction {
    type: typeof PROPOSED_REGULATION_RECEIVED;
    payload: { proposedRegulationReceived: ProposedRegulationReceived };
}

export interface AllProposedRegulationReceivedAction {
    type: typeof ALL_PROPOSED_REGULATION_RECEIVED;
    payload: {
        allProposedRegulationReceived: ProposedRegulationReceived;
        requestOrigin: RegulationRequestOrigin | null;
    };
}

export interface GetAllProposedRegulationsByIdAction {
    type: typeof GET_ALL_PROPOSED_REGULATIONS_BY_ID;
    payload: {
        params: ProposedRegulationReceived;
        requestOrigin: RegulationRequestOrigin | null;
        offset?: number;
        type?: string;
    };
}
// Update Proposed Restriction

export type ProposedRegulationId = number;
export type ProposedRegulationBody = { [prop: string]: any };
export type ProposedRegulationUpdated = { [prop: string]: any };
export type ProposedRegulationDeleted = ProposedRegulationId;

export interface UpdateProposedRegulationAction {
    type: typeof UPDATE_PROPOSED_REGUATION;
    payload: {
        id: ProposedRegulationId;
        proposedRegulationBody: ProposedRegulationBody;
        nextProcess?: () => void;
        updateRestrictionsData?: { [id: number]: ProposedRestrictionBody };
        isRedirectedFromEditPanel?: boolean;
    };
}

export const UPDATE_ZONE_ACTION = "UPDATE_ZONE_ACTION";

export interface updateZoneAction {
    type: typeof UPDATE_ZONE_ACTION;
    payload: {
        zoneId: ProposedRegulationId;
        zoneBody: ProposedRegulationBody;
        nextProcess?: (data: any) => void;
    };
}

export interface ProposedRegulationUpdatedAction {
    type: typeof PROPOSED_REGULATION_UPDATED;
    payload: { id: ProposedRegulationId; proposedRegulationUpdated: ProposedRegulationUpdated };
}

// Proposed Restriction

export type GetProposedRestriction = GetRequestSingleItemInterface;

export interface GetProposedRestrictionAction {
    type: typeof GET_PROPOSED_RESTRICTION;
    payload: { params: GetProposedRestriction };
}

export interface ProposedRestrictionReceivedRecord {
    id?: number;
    days_of_week?: Array<daysOfWeek>;
    from_time?: string;
    to_time?: string;
    effective_date_from?: string;
    effective_date_to?: string;
    day?: string;
    newId?: string;
    regulation?: {
        id: number;
    };
}
export interface ProposedRestrictionReceived extends GetResponseInterface {
    results: Array<ProposedRestrictionReceivedRecord>;
}

export interface ProposedRestrictionReceivedAction {
    type: typeof PROPOSED_RESTRICTION_RECEIVED;
    payload: { proposedRestrictionReceived: ProposedRestrictionReceived };
}

// Delete Proposed Regulation
export interface DeleteProposedRegulationAction {
    type: typeof DELETE_PROPOSED_REGULATION;
    payload: { id: ProposedRegulationId; afterProcess?: () => void };
}

export interface ProposedRegulationDeletedAction {
    type: typeof PROPOSED_REGULATION_DELETED;
    payload: {
        id: ProposedRegulationDeleted;
        proposedRegulationDeleted: ProposedRegulationDeleted;
    };
}

// Update Proposed Restriction

export type ProposedRestrictionId = number;
export type ProposedRestrictionBody = { [prop: string]: any };
export type ProposedRestrictionUpdated = { [prop: string]: any };
export type ProposedRestrictionDeleted = ProposedRestrictionId;

export interface UpdateProposedRestrictionAction {
    type: typeof UPDATE_PROPOSED_RESTRICTION;
    payload: { id: ProposedRestrictionId; proposedRestrictionBody: ProposedRestrictionBody };
}

export interface ProposedRestrictionUpdatedAction {
    type: typeof PROPOSED_RESTRICTION_UPDATED;
    payload: { id: ProposedRestrictionId; proposedRestrictionUpdated: ProposedRestrictionUpdated };
}

// Delete Proposed Restriction
export interface DeleteProposedRestrictionAction {
    type: typeof DELETE_PROPOSED_RESTRICTION;
    payload: { id: ProposedRestrictionId };
}

export interface ProposedRestrictionDeletedAction {
    type: typeof PROPOSED_RESTRICTION_DELETED;
    payload: { id: ProposedRestrictionId; proposedRestrictionDeleted: ProposedRestrictionDeleted };
}

// Get Regulation Links

// Proposed Restriction

export type GetRegulationLinks = GetRequestInterface;

export interface GetRegulationLinksAction {
    type: typeof GET_REGULATION_LINKS;
    payload: { params: GetRegulationLinks; actionType?: ActionType };
}

export interface GetProposedRegulationLinksAction {
    type: typeof GET_PROPOSED_REGULATION_LINKS;
    payload: {
        params: GetRegulationLinks;
        segmentObject?: segmentObject;
        updateLinkFunc?: updateLinkFunc;
        actionType?: ActionType;
    };
}

export interface RegulationLinksReceived extends GetResponseInterface {
    results: Array<{
        id?: number;
        regulation?: {
            regulationlinks_set: Array<{
                curb_link: {
                    bays_count: number;
                    street_name: string | null;
                    bl_street_name: string | null;
                };
            }>;
        };
        curb_link?: {
            id?: number;
            permits?: PermitParkingValue[];
        };
    }>;
    bays_angle_choices?: [];
}

export interface RegulationLinksReceivedAction {
    type: typeof REGULATION_LINKS_RECEIVED;
    payload: { regulationLinksReceived: RegulationLinksReceived };
}

// post proposed restriction
export interface PostProposedRestrictionPayload extends ProposedRestrictionBody {
    regulation_id: number;
}
export interface PostProposedRestrictionAction {
    type: typeof POST_PROPOSED_RESTRICTION;
    payload: { payload: PostProposedRestrictionPayload; isLastRestriction: boolean };
}

export type segmentObject = { object: CurbLinkRecord };

export type LinkHasProposedRegulationExtraParams = {
    [prop: string]: string | number | boolean;
};

export type updateLinkFunc = (
    segmentObject: SegmentObject,
    arg1?: LinkHasProposedRegulationExtraParams
) => void;

export interface CheckLinkHasProposedRegulation {
    type: typeof CHECK_LINK_HAS_PROPOSED_REGULATION;
    payload: {
        segmentObject: segmentObject;
        updateLinkFunc: updateLinkFunc;
        extraParams: LinkHasProposedRegulationExtraParams;
    };
}

export interface CheckRegulationHasProposedRegulation {
    type: typeof CHECK_REGULATION_HAS_PROPOSED_REGULATION;
    payload: { segmentObject: segmentObject; updateLinkFunc: updateLinkFunc };
}

export interface ReceivedCheckRegulationHasProposedRegulation {
    type: typeof RECEIVED_CHECK_REGULATION_HAS_PROPOSED_REGULATION;
}

export interface ToggleCreateOrEditActionPerformed {
    type: typeof TOGGLE_CREATE_OR_EDIT_ACTION_PERFORMED;
}

export type RegulationTypes =
    | UpdateFilteredLinksAction
    | UpdateFilteredProposedLinksAction
    | GetRegulationSectionAction
    | RegulationSectionReceivedAction
    | toggleEditRegulationPanelAction
    | ToggleEditOptionsPanelAction
    | GetAllRestrictionsAction
    | AllRestrictionsReceivedAction
    | CopyRegulationToProposedAction
    | RegulationToProposedPostedAction
    | GetProposedRegulationAction
    | ProposedRegulationReceivedAction
    | AllProposedRegulationReceivedAction
    | GetRegulationsAndRatesForScenarioAction
    | RegulationsAndRatesForScenarioReceivedAction
    | GetAllProposedRegulationsByIdAction
    | UpdateProposedRegulationAction
    | ProposedRegulationUpdatedAction
    | GetProposedRestrictionAction
    | ProposedRestrictionReceivedAction
    | UpdateProposedRestrictionAction
    | ProposedRestrictionUpdatedAction
    | DeleteProposedRestrictionAction
    | ProposedRestrictionDeletedAction
    | DeleteProposedRegulationAction
    | ProposedRegulationDeletedAction
    | GetRegulationLinksAction
    | GetProposedRegulationLinksAction
    | RegulationLinksReceivedAction
    | PostProposedRestrictionAction
    | CheckLinkHasProposedRegulation
    | CheckRegulationHasProposedRegulation
    | ReceivedCheckRegulationHasProposedRegulation
    | ResetStateAction
    | ToggleCreateOrEditActionPerformed
    | updateZoneAction;

export interface RegulationState {
    requestOrigin: RegulationRequestOrigin | null;

    filteredLinks: UpdateFilteredLinks;
    filteredProposedLinks: UpdateFilteredProposedLinks;
    regulationSection: RegulationSectionReceived;
    isRegulationSectionReceived: boolean;
    regulationId: regulationId;
    isEditRegulationPanelOpen: isEditRegulationPanelOpen;
    isEditOptionsPanelOpen: IsEditOptionsPanelOpen;
    allRestrictions: AllRestrictionsReceived;
    allRegulationsAndRatesForScenario: RegulationsAndRatesForScenario;
    isAllRestrictionsReceived: boolean;
    regulationToProposedPosted: RegulationToProposedPosted;
    isCopyRegulationToProposedPosted: boolean;
    toggleCreateorEditActionPerformed: boolean;

    // Proposed Regulation

    isProposedRegulationReceived: boolean;
    proposedRegulationReceived: ProposedRegulationReceived;
    allProposedRegulationReceived: ProposedRegulationReceived;

    isProposedRegulationUpdated: boolean;
    proposedRegulationUpdated: ProposedRegulationUpdated;
    proposedRegulationBody: ProposedRegulationBody;

    isProposedRegulationDeleted: boolean;
    proposedRegulationDeleted: ProposedRegulationDeleted;
    isRegulationHasProposedRegulationCheckInProgress: boolean;

    // Proposed Restriction

    isProposedRestrictionReceived: boolean;
    proposedRestrictionReceived: ProposedRestrictionReceived;

    isProposedRestrictionUpdated: boolean;
    proposedRestrictionUpdated: ProposedRestrictionUpdated;
    proposedRestrictionBody: ProposedRestrictionBody;

    isProposedRestrictionDeleted: boolean;
    proposedRestrictionDeleted: ProposedRestrictionDeleted;

    // Regulation Links

    isRegulationLinksReceived: boolean;
    regulationLinksReceived: RegulationLinksReceived;
}

export type ActionType = string;
